export const HOUSING_UNAVAILABLE = 'Housing data unavailable. Check local housing information before relying on this assessment.';
const failure = /error|fail|timeout|timed out|unavailable|not available|could not|unable to|no (?:housing )?data/i;
const number = (value, maximum = Infinity) => typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= maximum ? value : null;

export function formatHousingResult(data) {
  const unknown = { status: 'Unknown', public_rate: null, details: HOUSING_UNAVAILABLE };
  if (!data || typeof data !== 'object' || Array.isArray(data)) return unknown;
  const status = String(data.status || '').trim().toLowerCase();
  if (data.error || data.success === false || ['unknown', 'error', 'failed', 'unavailable'].includes(status) ||
      ['status', 'details', 'message', 'note', 'data_granularity', 'data_source'].some(key => failure.test(String(data[key] || '')))) return unknown;
  const rawRates = [data.public_housing?.rate ?? data.public_housing_rate, data.owner_occupied?.rate ?? data.owner_occupied_rate, data.private_rental?.rate ?? data.private_rental_rate];
  const rates = rawRates.map(value => number(value, 100));
  if (rawRates.some((value, index) => value != null && rates[index] == null)) return unknown;
  const [publicRate, ownerRate, privateRate] = rates;
  const positiveStatus = ['high', 'very_high', 'moderate', 'warning', 'detected'].includes(status);
  if (publicRate == null && !positiveStatus && status !== 'low') return unknown;
  if (publicRate === 0 && !(ownerRate > 0 || privateRate > 0 || number(data.total_dwellings) > 0)) return unknown;
  const high = positiveStatus || publicRate > 5;
  return {
    status: high ? 'Detected' : publicRate > 0 || status === 'low' ? 'Low' : 'Not Detected',
    public_rate: publicRate, public_count: number(data.public_housing?.count ?? data.public_housing_count),
    owner_rate: ownerRate, private_rate: privateRate,
    suburb: data.sa2_name || data.suburb || data.matched_suburb || 'Location unavailable',
    pocket_level: data.pocket_level === true, sa1_code: data.sa1_code,
    data_granularity: data.data_granularity,
    risk_level: high ? 'High' : 'Low', is_high_risk: high,
    data_source: data.data_source || 'Source not provided',
    public_rank: number(data.public_housing?.percentile ?? data.public_housing_rank),
    details: publicRate == null ? 'Housing presence reported; supporting figures unavailable.' : `${publicRate}% public housing${data.pocket_level === false ? ' (suburb-level data)' : ''}.`,
  };
}
